import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: '#ffffff',
        border: '1px solid #E4E7EC',
        borderRadius: 8,
        padding: '46px 48px 42px',
    },
    eyebrow: {
        letterSpacing: 1,
        color: theme.palette.primary.main,
        marginBottom: 20,
        display: 'block',
    },
    headline: {
        maxWidth: '16ch',
        marginBottom: 22,
        lineHeight: 1.13,
        letterSpacing: '-0.015em',
    },
    intro: {
        maxWidth: '62ch',
        color: theme.palette.text.secondary,
        marginBottom: 12,
    },
    ctaRow: {
        display: 'flex',
        gap: 14,
        marginTop: 16,
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    note: {
        display: 'flex',
        gap: 20,
        marginTop: 18,
        color: theme.palette.text.secondary,
    },
}));
